/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon16Solid = forwardRef('ArrowShapeTriangleAUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.348 11H4.651a.9.9 0 0 1-.756-1.388l3.349-5.19a.9.9 0 0 1 1.512 0l3.348 5.19A.9.9 0 0 1 11.348 11Z" })));
});
